import { useContext } from 'react';
import { type ControllableElement } from '@bynder-studio/render-core';
import { EditorSelectedElementContext } from '~/contexts/EditorSelectedElementContext';

export default function useEditorSelectedElement<T extends ControllableElement>() {
    const {
        selectedElement,
        selectedElements,
        topLevelSelectedElements,
        selectedElementDeferred,
        selectedElementsDeferred,
        topLevelSelectedElementsDeferred,
    } = useContext(EditorSelectedElementContext);

    return {
        selectedElement: selectedElement as T,
        selectedElements,
        topLevelSelectedElements,
        selectedElementDeferred,
        selectedElementsDeferred,
        topLevelSelectedElementsDeferred,
    };
}
